module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: [_vm.showNavBar ? 'app-main' : 'no-nav-app-main']
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless",
    class: [_vm.showNavBar ? 'app-content' : 'no-nav-app-content']
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-764432df!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/AppMain.vue
// module id = 337
// module chunks = 1